import React from "react";
import { bonuses } from "../data/landing";
export function BonusSection() {
  return <section className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-id="element-13" data-mp="1og3yoxzxcd42">
      <div className="text-center" data-id="element-14" data-mp="1ohyb1nx4qwwj">
        <p className="font-display text-xl text-muted" data-id="element-15" data-mp="22g532nfee2oa">Pero eso no es todo.</p>
        <h2 className="mt-2 font-display text-2xl font-bold leading-snug text-ink md:text-3xl" data-id="element-16" data-mp="1ye1ovr1cgjzb">
          Además de la colección completa, hoy recibes 3 bonos adicionales
        </h2>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-17" data-mp="15pcknj4zryjc">
        {bonuses.map(b => <article key={b.label} className="flex flex-col overflow-hidden rounded-2xl bg-paper shadow-sm" data-id="element-18" data-mp="15njc1yatj48p">
            <div className="relative" data-id="element-19" data-mp="1jilnt22cjntf">
              <img src={b.src} alt={`Portada del bono: ${b.title}`} className="aspect-[1410/1115] w-full object-cover" loading="lazy" data-id="element-20" data-mp="1eoznm9dddcei" />
              <span className="absolute left-3 top-3 rounded-full bg-plum px-3 py-1 text-xs font-extrabold text-paper" data-id="element-21" data-mp="my3bjaz4vbsa">
                {b.label}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5" data-id="element-22" data-mp="2eq4jzv28tgkj">
              <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-23" data-mp="2eothrzog4gvj">{b.title}</h3>
              <p className="mt-3 leading-relaxed text-muted" data-id="element-24" data-mp="2jk8takyze0os">{b.body}</p>
            </div>
          </article>)}
      </div>
    </section>;
}